<template>
  <div>

    <!-- Botones, sólo Jefes de departamento -->
    <div class="w-full">
      <div class="p-2- text-gray-900 bg-white rounded-lg shadow-lg- font-medium capitalize text-right">
        <template v-if="project.can_admin || project.can_collaborate">
          <project-assignments-report :openWithButton="false"/>
        </template>
      </div>

    </div>

    <div>
    
      <b-tabs type="is-boxed">
        <!-- Resource -->
        <b-tab-item>
          <template #header>
            <span> {{ $t("resources") }}
              <b-icon v-show="isLoadingResource"
                pack="fas"
                icon="spinner"
                class="fa-pulse"
                size="is-small">
              </b-icon>
            </span> 
          </template>

          <measurement
            type="resource"
            :project="project"
            :user="user"
            :orders="orders"
            :isLoading="isLoadingTable"
            :page="currentPage"
            :perPage="perPage"
            :total="total"
            :orderField="orderField"
            :orderDir="orderDir"
            @onSort="onSort"
            @onPageChange="onPageChange"
            @filtersUpdated="filtersUpdated"
            @reload="reload"
            @close-import="showImportExecutedQuantity = false"
            />
        </b-tab-item>

        <!-- Task -->
        <b-tab-item>
          <template #header>
            <span> {{ $t("tasks") }}
              <b-icon v-show="isLoadingTask"
                pack="fas"
                icon="spinner"
                class="fa-pulse"
                size="is-small">
              </b-icon>
              
            </span>
          </template>

          <measurement
            type="task"
            :project="project"
            :user="user"
            :orders="orders"
            :isLoading="isLoadingTable"
            :page="currentPage"
            :perPage="perPage"
            :total="total"
            :orderField="orderField"
            :orderDir="orderDir"
            @onSort="onSort"
            @onPageChange="onPageChange"
            @filtersUpdated="filtersUpdated"
            @reload="reload"/>
        </b-tab-item>

        <!-- certifier -->
        <b-tab-item>
          <template #header>
            <span> {{ $t("certifiers") }}
              <b-icon v-show="isLoadingTask"
                pack="fas"
                icon="spinner"
                class="fa-pulse"
                size="is-small">
              </b-icon>
              
            </span>
          </template>

          <measurement
            type="certifier"
            :project="project"
            :user="user"
            :orders="orders"
            :isLoading="isLoadingTable"
            :page="currentPage"
            :perPage="perPage"
            :total="total"
            :orderField="orderField"
            :orderDir="orderDir"
            @onSort="onSort"
            @onPageChange="onPageChange"
            @filtersUpdated="filtersUpdated"
            @reload="reload"/>
        </b-tab-item>

        <!-- certifier-head -->
        <b-tab-item>
          <template #header>
            <span> {{ $t("certifiers_chapters") }}
              <b-icon v-show="isLoadingTask"
                pack="fas"
                icon="spinner"
                class="fa-pulse"
                size="is-small">
              </b-icon>
              
            </span>
          </template>

          <measurement
            type="certifier-head"
            :project="project"
            :user="user"
            :orders="orders"
            :isLoading="isLoadingTable"
            :page="currentPage"
            :perPage="perPage"
            :total="total"
            :orderField="orderField"
            :orderDir="orderDir"
            @onSort="onSort"
            @onPageChange="onPageChange"
            @filtersUpdated="filtersUpdated"
            @reload="reload"/>
        </b-tab-item>

        <!-- Etiquetas (tag chapters). Solo se muestra si el proyecto tiene capitulos etiqueta creados. -->
        <b-tab-item v-if="hasTagChapters">
          <template #header>
            <span>
              <b-icon pack="fas" icon="tags" size="is-small" class="mr-1" />
              {{ $t("tags") }}
            </span>
          </template>

          <tag-chapters-tree :project="project" />
        </b-tab-item>

      </b-tabs>
    </div>


  </div>
</template>

<script>
  import Vue from "vue"
  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import Buefy from 'buefy'
  import BIcon from "buefy/src/components/icon/Icon";
  import EventBus from '~/plugins/bus'
  import projectAssignmentsReport from '·/components/project-assignments-report';
  import measurement from "./measurement.vue";
  import tagChaptersTree from "·/components/measurements/tag-chapters-tree.vue";

  Vue.use(Buefy);

  export default {
    middleware: 'auth',
    title: 'measurements_page_title',
    subtitle: 'measurements_page_subtitle',
    menuOption: '2-6',

    components: {
      BIcon,
      projectAssignmentsReport,
      measurement,
      tagChaptersTree,
    },

    computed: {
      ...mapGetters({
        user: 'auth/user',
        project: 'app/project',
        mobile: 'device/mobile',
        company: 'app/company',
      }),

      stickyHeader() { return this.mobile.on_mobile}, // para fiar el header de la tabla cuando se esta mostrando en movil

      executedQuantityLabel() {
        let label = this.$t('executed_quantity');
        if (this.company.alias == 'welink') {
          label = this.$t('inspected_quantity');
        }
        return label;
      },

      pendingQuantityLabel() {
        let label = this.$t('pending_validation_quantity');
        if (this.company.alias == 'welink') {
          label = this.$t('pending_inspect');
        }
        return label;
      },

      progressLabel() {
        let label = this.$t('progress_label');
        if (this.company.alias == 'welink') {
          label = this.$t('progress_inspected_label');
        }
        return label;
      }
    },

    data: () => ({
      // paginationRows: 10,
      entityId: 0, // ID de la actividad clicada
      isLoadingTable: true,
      page: 1,
      currentPage: 1,
      last: 1,
      perPage: 25,
      total: 0,
      orderField: "name",
      orderDir: "desc",
      list: [],
      filterPendingValidation: null,
      isLoadingResource: false,
      isLoadingTask: false,
      hasTagChapters: false, // controla la visibilidad del tab "Etiquetas"

      orders: [] // es cargado desde el componente measurement-filters
    }),

    created() {

    },

    mounted() {
      // this.applyFilters(this.page);
      let self = this;

      this.checkHasTagChapters();

      EventBus.$on("refreshAssignmentChangedNotifications", function (e) {
        if (self.project.id === e.project_id) {
          self.isLoading = true;
          self.applyFilters(self.page);
        }
      });
      EventBus.$on("refreshAssignmentCreatedNotifications", function (e) {
        if (self.project.id === e.project_id) {
          self.isLoading = true;
          self.applyFilters(self.page);
        }
      });
      EventBus.$on("refreshAssignmentDeletedNotifications", function (e) {
        if (self.project.id === e.project_id) {
          self.isLoading = true;
          self.applyFilters(self.page);
        }
      });
    },

    beforeDestroy(){
      EventBus.$off("refreshAssignmentChangedNotifications");
  	  EventBus.$off("refreshAssignmentCreatedNotifications");
  	  EventBus.$off("refreshAssignmentDeletedNotifications");
    },

    methods: {
      // Comprueba si el proyecto tiene capitulos etiqueta para decidir si mostrar el tab "Etiquetas".
      async checkHasTagChapters() {
        try {
          const { data } = await axios.get(`/api/v2/project/${this.project.id}/tag-chapters/tree`);
          this.hasTagChapters = !!(data && data.success && Array.isArray(data.chapters) && data.chapters.length > 0);
        } catch (e) {
          this.hasTagChapters = false;
        }
      },

      async getList(args = []) {

        // const {data} = await axios.get('/api/v2/project/' + this.project.id + '/assignments?page=' + this.page, {params: args});
        const {data} = await axios.get('/api/v2/project/' + this.project.id + '/assignments', {params: args});

        // Last and total
        this.last = data.lastPage;
        this.total = data.total;

        if (data && data.assignments) {
          this.list = data.assignments;
        } else {
          this.$notify.error('error_loading_assignment_data');
        }

        this.isLoadingTable = false;
      },

      // OJO. realmente esto no se usa. Se delega en el component hijo measurement.vue
      customizeFilters() {
        let filters = this.$refs.filtersRef.generateFilters();
        filters.with_parent = 1;
        filters.with_assignments = 1;
        filters.order_field = this.orderField;
        filters.order_dir = this.orderDir;
        filters.per_page = this.perPage;
        if( typeof filters.where_pending_validation === 'undefined' &&  this.$route.query.pending_validation ) {
          filters.where_pending_validation = 'pending'
        }
        return filters;
      },

      /**
       * Cambia la ventana a la tabla de actividades normal
       */
      displayTable() {
        this.$router.push({name: 'project.activities'});
      },

      displayKanban() {
        this.$router.push({name: 'project.activities.kanban'});
      },

      displayGantt() {
        this.$router.push({name: 'project.activities.gantt'});
      },

      filtersUpdated() {
        this.isLoadingTable = true;
        this.applyFilters(1);
      },

      applyFilters(page) {
        let args = this.customizeFilters();
        args.page = (page <= this.last) ? page : 1;
        this.currentPage = args.page;
        this.getList(args);
      },

      fetchData() {
        if (this.page <= this.last) {
          this.isLoadingTable = true;
          this.applyFilters(this.page);
        }
      },

      onPageChange(page) {
        this.page = page;
        this.fetchData()
      },

      onSort(field, order) {
        this.orderField = field;
        this.orderDir = order;
        this.fetchData()
      },

      sortByCompleted(a, b, isAsc) {
        return isAsc ?
          a.completed - b.completed :
          b.completed - a.completed
      },

      isCompleted(row) {
        if (row.completed)
          return '<i class="fas fa-check text-green"/>';

        return '<i  class="fas fa-times text-red"/>';

      },

      // Modal para confirmar cantidades ejecutadas
      onClickValidate(row) {
        // User es usuario certificador del proyecto
        // if (!this.apiProject.can_validate)
        // if (!this.project.can_validate)
        //   return;

        // this.entityId = row.parentId;
        this.$refs.assignment_validate_quantity_modal.show(row.id);
      },

      getRowClass() {
        return '';
      },

      getAssignmentStatusColor(row) {
        switch (row.alert) {
          case -1:
            return 'bg-blue';

          case 0:
            return 'bg-green';

          case 1:
            return 'bg-red';

          default:
            return 'bg-blue';
        }
      },

      getAssignmentStatusLabel(row) {
        switch (row.alert) {
          case -1:
            return 'assignments-under';

          case 0:
            return 'assignments-completed';

          case 1:
            return 'assignments-over';
        }
      },

      /**
       * Calcula el estado de la medición
       * @param row
       * @returns {number}
       */
      getAssignmentStatus(row) {
        if (row.type === 'task')
          if (row.completed)
            return 0; // perfecto
          else return -1;// por debajo, tarea aun no completada

        if (row.executed_quantity < row.total)
          return -1; // por debajo
        else if (row.executed_quantity > row.total)
          return 1; // por encima
        else return 0; // cantidad exacta
      },

      /**
       * Comprueba si puede abrir el modal de editado para una fila en concreto
       */
      canOpenEditModal(row) {
        if (row.user_id != this.user.id && this.isTask(row)) return false;
        return true;
      },

      /**
       * Abre el modal para editar una medición
       */
      onClickEdit(row) {
        if (!this.canOpenEditModal(row)) {
          return;
        }
        this.entityId = row.assignable_id;
        this.$refs.assignment_update_modal.show(row);
      },

      openActivity(activity) {
        if (!activity.parent_id) {
          this.$router.push({name: 'activity.home', params: { activity_id: activity.id } } )
        } else {
          this.$router.push({
            name: 'subactivity.home',
            params: { activity_id: activity.parent_id, subactivity_id: activity.id }
          })
        }

      },

      getRemaining(row) {
        if (this.isTask(row)) return "---";

        if (row.completed)
          return this.twoDecimals(0);

        return this.twoDecimals(row.total_quantity - row.executed_quantity);
      },

      isSubActivity(row) {
        return row.parent_id != null;
      },

      isTask(row) {
        if (row.type === 'task')
          return true;
      },

      reload(data) {
        self.isLoading = true;
        this.applyFilters(this.page);
      },

      /**
       * Convierte el numero a dos decimales obligatoriamente
       * @param number
       * @returns {string}
       */
      twoDecimals(number) {
        if (number == null)
          number = 0;
        return parseFloat(number).toFixed(2);
      },

      loadedOrders(data) {
        this.orders = data
      },

      getNamePartner(idOrder) {

        if (! idOrder) return null
        let name = null
        let order = this.orders.find(o => idOrder == o.id)
        if (order) {
          let partners = order.partners.map(p => p.name )
          name = partners.join(',')
        }

        return name
      },
     
      onImportSuccess() {
        this.showImportExecutedQuantity = false;
        this.fetchData(); 
      }

    },

  };
</script>

<style lang="scss" scoped>
  .panel::v-deep .b-table .table-wrapper.has-sticky-header tr:first-child th {
    background: hsl(220, 43%, 53%);
  }
  .vertical-center {
    vertical-align: inherit !important;
  }

  .clickable {
    cursor: pointer;
  }

  .subactivities {
    .table th {
      background-color: #89a4d6;
    }

    &.b-table .table.is-bordered th.is-current-sort, &.b-table .table.is-bordered th.is-sortable:hover {
      background-color: #89a4d6 !important;
    }
  }

  .b-table .table-wrapper.has-sticky-header tr:first-child th {
    // background-color: $primary !important;
    min-height: 3rem;
  }
</style>
